import objectToFormData from 'object-to-formdata';

class RequestParser {
    static toQueryString = (data, alias) => `${Object.keys(data)
        .filter((key) => Boolean(data[key]))
        .map((key) => `${alias ? `${encodeURIComponent(alias)}.` : ''}${encodeURIComponent(key.extensions.unCapitalize())}=${encodeURIComponent(data[key])}`)
        .join('&')}`;

    static toBody = (data) => {
        const result = {};
        if (isObject(data)) {
            Object.keys(data).forEach((key) => {
                result[key.extensions.capitalize()] = RequestParser.toBody(data[key]);
            });
            return result;
        }
        return data;
    };

    static toFormData = (data, files = [], filesKey = 'Files') => {
        const body = RequestParser.toBody(data);
        const result = objectToFormData(body);
        if (files.length) files.forEach((file) => result.append(filesKey.extensions.capitalize(), file));
        return result;
    };

    static prepareDateToSend = (data, dateKey) => {
        const newData = { ...data };
        const date = newData[dateKey];
        if (date) {
            newData[dateKey] = date.toUTCString();
        } else {
            delete newData[dateKey];
        }
        return newData;
    };
}

const isObject = (obj) => !Array.isArray(obj)
 && typeof obj !== 'string'
 && !(obj instanceof Date)
 && typeof obj !== 'boolean'
 && typeof obj !== 'number'
 && obj !== null
 && obj !== undefined;

export default RequestParser;
